import { Navigate, Outlet, useLocation } from 'react-router'
import { useMessages } from '@/features/language/use-language'
import { StatusMessage } from '@/shared/ui/StatusMessage'
import { useSession } from './use-session'

/**
 * 화면 편의를 위한 가드다. 신뢰 경계는 언제나 Backend이고 이 컴포넌트는 접근통제가 아니다.
 */
export function RequireAuth() {
  const m = useMessages()
  const session = useSession()
  const location = useLocation()

  if (session.status === 'loading') {
    return <StatusMessage>{m.auth.gate.opening}</StatusMessage>
  }
  if (session.status === 'anonymous') {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname, sessionExpired: session.expired }}
      />
    )
  }
  if (session.status === 'error') {
    return (
      <StatusMessage action={{ label: m.app.common.retry, onClick: session.refresh }}>
        {m.auth.gate.unreachable}
      </StatusMessage>
    )
  }
  return <Outlet />
}
